import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { BsModalService } from 'ngx-bootstrap';
import { ScoreService } from '../../../../common/services/Score.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';

declare var $: any;
declare var Chartist: any;

@Component({
  templateUrl: 'score.template.html',
  styleUrls: ['score.css'],
  providers: [BsModalService, ScoreService],
})
export class ScoreComponent implements OnInit {
  public scoreMode: any = 'list';
  public choice_score_id: any;
  constructor() {}

  ngOnInit() {}

  openMode($event) {
    this.scoreMode = $event.scoreMode;
    if (this.scoreMode == 'detail') {
      this.choice_score_id = $event.score_id;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/score/score.component.ts